var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-arrow-right';
                    var viewUrl = 'gfx/sprite.svg#view-icon-arrow-right';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };